import React from 'react';
import { ButtonPrimaryTextOnly } from '@creditas-ui/button';
import { VerticalAlignedButtonsWrapper, HorizontalAlignedButtonsWrapper, SecondaryButton } from '../ModalFooter.style';

var VerticalAlignedButtons = _ref => {
  var {
    primaryLabel,
    secondaryLabel,
    onPrimaryButtonClick,
    onSecondaryButtonClick
  } = _ref;
  return /*#__PURE__*/React.createElement(VerticalAlignedButtonsWrapper, null, /*#__PURE__*/React.createElement(ButtonPrimaryTextOnly, {
    width: "fixed",
    maxWidth: 300,
    children: primaryLabel,
    size: "medium",
    onClick: onPrimaryButtonClick
  }), !!primaryLabel && !!secondaryLabel && /*#__PURE__*/React.createElement(SecondaryButton, {
    "data-testid": "modal-secondary-label",
    isVerticalAligned: true,
    onClick: onSecondaryButtonClick,
    children: secondaryLabel
  }));
};

var HorizontalAlignedButtons = _ref2 => {
  var {
    primaryLabel,
    secondaryLabel,
    onPrimaryButtonClick,
    onSecondaryButtonClick
  } = _ref2;
  return /*#__PURE__*/React.createElement(HorizontalAlignedButtonsWrapper, {
    "data-testid": "modal-footer-horizontal-alignment-wrapper"
  }, /*#__PURE__*/React.createElement(SecondaryButton, {
    className: "button-secondary",
    onClick: onSecondaryButtonClick,
    children: secondaryLabel
  }), /*#__PURE__*/React.createElement(ButtonPrimaryTextOnly, {
    children: primaryLabel,
    size: "medium",
    onClick: onPrimaryButtonClick
  }));
};

var helperVariant = {
  verticalAlignedButtons: VerticalAlignedButtons,
  horizontalAlignedButtons: HorizontalAlignedButtons
};
export default helperVariant;
//# sourceMappingURL=VariantHelper.js.map